module.exports = __webpack_public_path__ + "media/images/flags/32/Somalia-d96d796656b9b07fa3bf61a9d04c0725.png";